<template>
  <div class="warp">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="item">
          <div class="title">当前余额</div>
          <div class="item-text flex">
            <div class="flex-1">
              {{balance}}
            </div>
            <el-button size="small" type="primary" @click="topUp">充值</el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item">
          <div class="title">最后一次充值金额</div>
          <div class="item-text">{{lastTopUpValue}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item">
          <div class="title">最后一次充值时间</div>
          <div class="item-text">{{lastTopUpTime}}</div>
        </div>
      </el-col>
    </el-row>
    <div class="box" style="height:400px">
      <div class="title">最近5笔交易</div>
      <div class="table-content">
        <nk-table :data="tableData" :columns="columns" :showPage="false">
        </nk-table>
      </div>
    </div>

    <lt-msg-box :visible="dialogVisible" @cancel="dialogVisible = false" title="充值" @confirm="confirm">
      <div class="from-content">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="支付方式">
            <el-select v-model="form.channel">
              <el-option label="微信支付" :value="1"></el-option>
              <el-option label="支付宝支付" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值金额">
            <el-input v-model="form.amount"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </lt-msg-box>

    <PayDialog v-if="payVisible" :info="form" @close="payVisible = false"></PayDialog>
  </div>
</template>

<script>
import api from '@common/api/index.js'
import NkTable from '@/components/common/NkTable.vue'
import LtMsgBox from '@/components/common/LtMsgBox.vue'
import PayDialog from '../PayDialog.vue'

export default {
  components: { NkTable, LtMsgBox, PayDialog },
  data () {
    return {
      payType: { 1: '微信支付', 2: '支付宝支付' },
      tableData: [],
      columns: [
        {
          prop: "time",
          label: "交易时间",
          show: true,
        },
        {
          prop: "before",
          label: "变更前余额",
          show: true,
        },
        {
          prop: "delta",
          label: "变更金额",
          show: true,
        },
        {
          prop: "after",
          label: "变更后余额",
          show: true,
        },
        {
          prop: "remark",
          label: "费用描述",
          show: true,
        }],
      balance: '-',
      lastTopUpTime: '-',
      lastTopUpValue: '-',
      dialogVisible: false,
      form: {
        channel: 1,
        amount: null
      },
      rules: {
        channel: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        amount: [
          { pattern: /^-?\d+\.?\d*$/, message: '请输入正确金额', trigger: 'blur' }
        ],
      },
      payVisible: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      // 获取余额
      api.balance.getPersonalBalance().then(res => {
        if (res.data) {
          this.balance = res.data.balance
        }
      })

      // 最后一次充值记录
      api.balance.getPersonalBalanceTopUpOrderRecent(1, 2).then(res => {
        if (res.data && res.data.length > 0) {
          this.lastTopUpTime = res.data[0].time
          this.lastTopUpValue = res.data[0].amount
        }
        else {
          this.lastTopUpTime = '-'
          this.lastTopUpValue = '-'
        }
      })

      api.balance.getPersonalBalanceChangingLogRecent(5).then(res => {
        if (res.data && res.data.length > 0) {
          this.tableData = res.data
        }
        else {
          this.tableData = []
        }
      })
    },
    topUp () {
      this.form = {
        channel: 1,
        amount: null
      }
      this.dialogVisible = true
    },
    confirm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          api.balance.personalBalanceTopUp(this.form.channel, this.form.amount).then(res => {
            if (res.data) {
              this.dialogVisible = false
              this.form.orderId = res.data.orderId
              this.payVisible = true
              this.form.paymentCode = res.data.paymentCode
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 0px 14px;
  box-sizing: border-box;
  text-align: left;
  color: #2e3842;
  .item {
    border: 1px solid #eee;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
  }
  .box {
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #eee;
    background: #fff;
  }
  .title {
    font-size: 22px;
  }
  .item-text {
    font-size: 28px;
    padding-top: 10px;
  }
  .table-content {
    width: 100%;
    height: 340px;
    margin-top: 10px;
  }
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.from-content {
  padding: 0px 10px;
}
</style>